<h1 class="u-sr-only">{{ 'Profile.Menu.Transactions' | translate }}</h1>
<section class="c-section c-section--first u-no-pb" [ngClass]="{'u-hidden@md-and-up': vm.type===1, 'c-section--last': !vm.tabs}" panel [isOpen]="true">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{'Wallet.Title.Recent' | translate}}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card">
					<div class="c-content u-hidden@up-to-md" *ngIf="vm.tabs">
						<list-tabs [tabs]="vm.tabs" [(activeTab)]="vm.type" [isSmall]="true"></list-tabs>
					</div>
					<div class="c-content c-content--wrapper u-no-p@up-to-md" [ngStyle]="!vm.transaction?.length && {'min-height': '300px'}">
						<table-transactions [(transactions)]="vm.transactions" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-transactions>
					</div>
					<div *ngIf="vm.transactions && vm.transactions?.length > vm.pageSize">
						<div class="o-grid u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
								<list-pager [totalItems]="vm.transactions.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="c-section c-section--last u-no-pb" *ngIf="vm.tabs" [ngClass]="{'u-hidden@md-and-up': !vm.type}" panel>
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{'Wallet.Title.My_Earnings' | translate}}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card">
					<div class="c-content u-hidden@up-to-md">
						<list-tabs [tabs]="vm.tabs" [(activeTab)]="vm.type" [isSmall]="true"></list-tabs>
					</div>
					<div class="c-content c-content--wrapper u-no-p@up-to-md" [ngStyle]="!vm.transaction?.length && {'min-height': '300px'}">
						<table-transactions [(transactions)]="vm.incomes" [showIncomeOnly]="true" [(currentPage)]="vm.incomeCurrentPage" (currentPageChange)="vm.incomeCurrentPageChanged($event)"></table-transactions>
					</div>
					<div *ngIf="vm.incomes && vm.incomes?.length > vm.incomePageSize">
						<div class="o-grid u-ost-md u-osb-md">
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
								<list-pager [totalItems]="vm.incomes.length" [pageSize]="vm.incomePageSize" [(currentPage)]="vm.incomeCurrentPage" (currentPageChange)="vm.incomeCurrentPageChanged($event)"></list-pager>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
